// Formato y criterios visuales de la proyección comercial (el cálculo vive en el
// backend: services/proyeccion_service.py).

export const MESES = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio',
  'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

export function fmtUSD(n, decimales = 0) {
  if (n == null) return '—';
  return 'USD ' + Number(n).toLocaleString('es-AR', {
    minimumFractionDigits: decimales, maximumFractionDigits: decimales,
  });
}

export function fmtPct(x) {
  if (x == null) return '—';
  const v = (x * 100).toLocaleString('es-AR', { maximumFractionDigits: 1 });
  return `${x > 0 ? '+' : ''}${v}%`;
}

// `corte` llega en hora argentina sin zona ("2026-10-16T11:30"): se formatea
// del string, sin pasar por Date, para no correrlo de huso.
export function fmtCorte(corte) {
  if (!corte) return '';
  const [fecha, hora = ''] = corte.split('T');
  const [, m, d] = fecha.split('-');
  return `${d}/${m} ${hora.slice(0, 5)}`;
}

export const unidadDia = (linea) => (linea?.calendario === 'corridos' ? 'día' : 'día hábil');
export const unidadDias = (linea) => (linea?.calendario === 'corridos' ? 'días' : 'días hábiles');

// Semáforo: compara el forecast contra el objetivo.
export function estadoLinea(linea, pocoDato) {
  if (!linea || !linea.objetivo) return { color: 'var(--text-3)', dim: 'var(--surface-3)', label: 'Sin objetivo' };
  if (linea.objetivo_alcanzado)   return { color: 'var(--green)', dim: 'var(--green-dim)', label: 'Objetivo cumplido' };
  if (pocoDato || linea.forecast_vs_obj == null)
    return { color: 'var(--text-2)', dim: 'var(--surface-3)', label: 'Poco dato todavía' };
  if (linea.forecast_vs_obj >= 0)    return { color: 'var(--green)', dim: 'var(--green-dim)', label: 'En camino' };
  if (linea.forecast_vs_obj >= -0.1) return { color: 'var(--amber)', dim: 'var(--amber-dim)', label: 'Ajustado' };
  return { color: 'var(--red)', dim: 'var(--red-dim)', label: 'Por debajo' };
}

// El mismo resumen "en criollo" que el mail diario.
export function textoCriollo(linea, { propia = true } = {}) {
  if (!linea) return '';
  const llevas = propia ? 'llevás' : 'van';
  if (!linea.objetivo) {
    return `Sin objetivo cargado este mes; ${llevas} ${fmtUSD(linea.real)} facturados.`;
  }
  if (linea.objetivo_alcanzado) {
    const extra = linea.forecast != null ? Math.max(0, linea.forecast - linea.objetivo) : null;
    return `Objetivo de ${fmtUSD(linea.objetivo)} cumplido: ${llevas} ${fmtUSD(linea.real)}.`
      + (extra ? ` Sosteniendo el promedio actual se cierra ~${fmtUSD(extra)} por encima.` : '');
  }
  const partes = [`El objetivo es ${fmtUSD(linea.objetivo)} y ${llevas} ${fmtUSD(linea.real)}.`];
  if (linea.forecast != null) partes.push(`A este ritmo se cierra en ${fmtUSD(linea.forecast)}.`);
  if (linea.ritmo_necesario != null) {
    partes.push(`Para llegar hacen falta ${fmtUSD(linea.ritmo_necesario)} por ${unidadDia(linea)} de acá a fin de mes.`);
  }
  return partes.join(' ');
}
